import { createActiveAdapter } from '@store/_abstract/active';

import { FunnelState } from '@store/_abstract/funnel/funnel.state';
import { createFunnelAdapter } from '@store/_abstract/funnel/funnel.adapter';
import { createHydratedAdapter, HydrationState } from '@store/_abstract/hydrated';

import { DoodCartFunnelStep, DoodCartFunnelValue } from './cart-funnel.model';

export const CART_FUNNEL_STORE_KEY = 'CartFunnel';

export interface CartFunnelState
  extends FunnelState<DoodCartFunnelStep, DoodCartFunnelValue, string>, HydrationState {
  activeCartId: string | null;
  orderComment: string | null;
  funnelUsername: string | null;
  displayableStepsIds: string[];
  seatCount: number | null;
}

export const CART_FUNNEL_STORE_ACTIVE_ADAPTER = createActiveAdapter<DoodCartFunnelStep, string>({
  sortComparer: (_prev, _next) => _prev.index - _next.index,
});
export const CART_FUNNEL_STORE_FUNNEL_ADAPTER = createFunnelAdapter<
  DoodCartFunnelStep,
  DoodCartFunnelValue,
  string
>();
export const CART_FUNNEL_STORE_HYDRATION_ADAPTER = createHydratedAdapter();

export const CART_FUNNEL_STORE_INITIAL_STATE: CartFunnelState =
  CART_FUNNEL_STORE_HYDRATION_ADAPTER.getInitialState(
    CART_FUNNEL_STORE_FUNNEL_ADAPTER.getInitialState<CartFunnelState>({
      activeCartId: null,
      orderComment: null,
      funnelUsername: null,
      displayableStepsIds: [],
      seatCount: null,
    }),
  );
